
// ============================
// File: src/features/discovery/components/ApproachRecommendation.jsx
// ============================
import React from "react";

export default function ApproachRecommendation({ result, isLoading, error }) {
  return (
    <section className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
      <h3 className="text-base font-semibold text-gray-900">Approach Recommendation</h3>
      <p className="text-sm text-gray-600 mb-3">AI narrative and scorecard</p>

      {isLoading && (
        <div className="animate-pulse rounded-lg border border-gray-200 p-4">
          <div className="h-3 w-1/3 rounded bg-gray-200" />
          <div className="mt-3 h-3 w-2/3 rounded bg-gray-200" />
        </div>
      )}

      {error && (
        <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800">{String(error.message || error)}</div>
      )}

      {!isLoading && !error && result && (
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <div className="text-sm text-gray-600">Recommended Path</div>
            <div className="text-base font-semibold text-gray-900">{result.discovery_path} ({Math.round((result.confidence || 0) * 100)}%)</div>
          </div>
          <div className="text-sm text-gray-800 whitespace-pre-wrap">{result.narrative}</div>
          {Array.isArray(result.risks) && result.risks.length > 0 && (
            <div className="text-sm text-gray-800">
              <div className="font-medium mb-1">Risks & Prerequisites</div>
              <ul className="list-disc ml-5 space-y-1">
                {result.risks.map((r, i) => <li key={i}>{r}</li>)}
              </ul>
            </div>
          )}
        </div>
      )}

      {!isLoading && !error && !result && (
        <div className="text-sm text-gray-600">Run a recommendation to see results.</div>
      )}
    </section>
  );
}